import { Component, HostListener, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ApplicationService } from "./services/application.service";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnDestroy {
  title = "Roar";
  private routerSubscription: Subscription;

  constructor(
    public dialog: MatDialog,
    private applicationService: ApplicationService,
    private router: Router
  ) {
    this.routerSubscription = this.router.events.subscribe((event) => this.handleRouteChange(event));
  }

  ngOnInit() {
    this.initializeApplication();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  /**
   * Eseguito quando l’utente lascia la pagina.
   */
  @HostListener("window:beforeunload", ["$event"])
  onBeforeUnload(event: Event) {
    if (environment.production) {
      // Se siamo su /subscription/renewal, saltiamo la logica di reload e clearStorage
      if (this.router.url.startsWith('/onlinereputation/renewal')) {
        return;
      }
      window.location.reload();
      this.clearStorage();
    }
  }

  /**
   * Eseguito quando la pagina è caricata.
   */
  @HostListener("window:load", ["$event"])
  onLoad(event: Event) {
    // Se siamo su una route pubblica (renewal / errore SSO), non forziamo la navigazione a /login
    if (this.isPublicRoute(this.router.url)) {
      return;
    }
    this.navigateToLogin();
  }

  private isPublicRoute(url: string): boolean {
    return url.startsWith('/onlinereputation/renewal') || url.startsWith('/errorsso');
  }

  private initializeApplication(): void {
    this.applicationService.getTranslate(this.applicationService.languageSelectValue);
  }

  private handleRouteChange(event: any): void {
    if (event instanceof NavigationStart) {
      if (environment.production && this.isAuthRelatedRoute(event.url)) {
        this.clearStorage();
      }
    }
  }

  private isAuthRelatedRoute(url: string): boolean {
    return url === '/login' || url === '/logoutsso';
  }

  private clearStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  private navigateToLogin(): void {
    this.router.navigate(["/login"]);
  }
}
